import { useLocalStorage } from 'react-use'

import { useActiveOrg } from '~/hooks/org'
import { IAddress } from '~/types'

export const useDefaultSmartAccount = (
  overrideValue?: IAddress,
  fallbackValue?: IAddress,
): [IAddress | undefined, (value: IAddress | undefined) => void] => {
  const { org } = useActiveOrg()
  const [, setDefaultSmartAccountAddress] = useLocalStorage<
    IAddress | undefined
  >(`splits.defaultSmartAccountSelectInput.${org?.id}`, undefined)

  if (overrideValue) {
    return [overrideValue, setDefaultSmartAccountAddress]
  }

  // Never auto-select from localStorage - only use explicit overrides or fallbacks
  // We still save the selection for future reference but don't auto-apply it
  // This ensures users must explicitly choose an account for each transaction
  return [fallbackValue, setDefaultSmartAccountAddress]
}
